<template>
  <v-container 
    fluid grey lighten-4 
    class="pa-0 my-0"
    id="atalhos"
  >
    <v-row
      class="pb-12 py-12 px-12"
    >
      <v-col
        v-for="(a,i) in atalhos"
        :key="i"
        cols="12"
        sm="6"
        md="4"
      >
        <v-card tile flat hover
          class="pb-4 fill-height transparent grey--text text--darken-4 text-left" 
          @click="$vuetify.goTo(a.url)"
        >
          <v-card-text>
            <v-icon
              x-large
              class="primary--text"
            >
              {{a.icone}}
            </v-icon>
          </v-card-text>
          <v-card-title class="pt-0 headline justify-left">
            <span class="font-weight-bold">{{a.titulo}}</span>
          </v-card-title>
          <v-card-subtitle class="pt-1 pb-2 caption text-uppercase">
            <span class="font-weight-medium grey--text text--darken-2">
              {{a.subtitulo}}
            </span>
          </v-card-subtitle>
          <v-spacer></v-spacer>
          <v-card-actions class="pl-3">
            <v-icon>mdi-chevron-down</v-icon>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import posts from '~/store/posts'
// import axios from '~/plugins/axios'

export default {
  data: () => ({
    atalhos: [
      {
        icone: 'mdi-office-building',
        titulo: 'Sobre o Instituto',
        subtitulo: 'Descubra quem somos e o que fazemos.',
        url: '#sobre'
      },
      {
        icone: 'mdi-teach',
        titulo: 'Treinamentos',
        subtitulo: 'Desenvolvimento pessoal e formação.',
        url: '#treinamentos'
      },
      {
        icone: 'mdi-account-circle-outline',
        titulo: 'Serviços',
        subtitulo: 'Saiba o que oferecemos e como podemos ajudá-lo.',
        url: '#servicos'
      }
    ],
  }),
  methods: {
    getImg(i) {
      return require('@/assets/img/'+i)
    },
  },
  created () {
    //this.posts = posts.getPosts()
  },

}
</script>